export const cardRequests = {
  items: [
    {
      requestId: 1,
      vehicleNumber: 'RECIPIENT 32',
      costCenter: 'Cost Center 1',
      cardName: 'Card 1',
      coverage: 'National',
      serviceCode: 82,
      email: 'risc@artoil.ro',
      phoneNumber: '0712341234',
      provider: 'MOL',
      dailyLimitRequested: 12345,
      weeklyLimitRequested: 34567,
      monthlyLimitRequested: 45678,
      dailyTransactionsRequested: 100,
      weeklyTransactionsRequested: 100,
      monthlyTransactionsRequested: 150
    },
    {
      requestId: 2,
      vehicleNumber: 'RECIPIENT 32',
      costCenter: 'Cost Center 1',
      cardName: 'Card 1',
      coverage: 'National',
      serviceCode: 82,
      email: 'risc@artoil.ro',
      phoneNumber: '0712341234',
      provider: 'MOL',
      dailyLimitRequested: 12345,
      weeklyLimitRequested: 34567,
      monthlyLimitRequested: 45678,
      dailyTransactionsRequested: 100,
      weeklyTransactionsRequested: 100,
      monthlyTransactionsRequested: 150
    },
    {
      requestId: 3,
      vehicleNumber: 'RECIPIENT 32',
      costCenter: 'Cost Center 1',
      cardName: 'Card 1',
      coverage: 'National',
      serviceCode: 82,
      email: 'risc@artoil.ro',
      phoneNumber: '0712341234',
      provider: 'MOL',
      dailyLimitRequested: 12345,
      weeklyLimitRequested: 34567,
      monthlyLimitRequested: 45678,
      dailyTransactionsRequested: 100,
      weeklyTransactionsRequested: 100,
      monthlyTransactionsRequested: 150
    },
    {
      requestId: 4,
      vehicleNumber: 'RECIPIENT 32',
      costCenter: 'Cost Center 1',
      cardName: 'Card 1',
      coverage: 'National',
      serviceCode: 82,
      email: 'risc@artoil.ro',
      phoneNumber: '0712341234',
      provider: 'MOL',
      dailyLimitRequested: 12345,
      weeklyLimitRequested: 34567,
      monthlyLimitRequested: 45678,
      dailyTransactionsRequested: 100,
      weeklyTransactionsRequested: 100,
      monthlyTransactionsRequested: 150
    },
    {
      requestId: 5,
      vehicleNumber: 'RECIPIENT 32',
      costCenter: 'Cost Center 1',
      cardName: 'Card 1',
      coverage: 'National',
      serviceCode: 82,
      email: 'risc@artoil.ro',
      phoneNumber: '0712341234',
      provider: 'MOL',
      dailyLimitRequested: 12345,
      weeklyLimitRequested: 34567,
      monthlyLimitRequested: 45678,
      dailyTransactionsRequested: 100,
      weeklyTransactionsRequested: 100,
      monthlyTransactionsRequested: 150
    },
    {
      requestId: 6,
      vehicleNumber: 'RECIPIENT 32',
      costCenter: 'Cost Center 1',
      cardName: 'Card 1',
      coverage: 'National',
      serviceCode: 82,
      email: 'risc@artoil.ro',
      phoneNumber: '0712341234',
      provider: 'MOL',
      dailyLimitRequested: 12345,
      weeklyLimitRequested: 34567,
      monthlyLimitRequested: 45678,
      dailyTransactionsRequested: 100,
      weeklyTransactionsRequested: 100,
      monthlyTransactionsRequested: 150
    }
  ],
  total: 6,
  totalPages: 1
};

export const cardRequestDetails = {
  requestId: 1,
  vehicleNumber: 'RECIPIENT 32',
  costCenter: 'Cost Center 1',
  cardName: 'Card 1',
  coverage: 'National',
  serviceCode: 82,
  email: 'risc@artoil.ro',
  phoneNumber: '0712341234',
  provider: 'MOL',
  dailyLimitRequested: 12345,
  weeklyLimitRequested: 34567,
  monthlyLimitRequested: 45678,
  dailyTransactionsRequested: 100,
  weeklyTransactionsRequested: 100,
  monthlyTransactionsRequested: 150
};
